/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Duration,
  HierarchicalTask,
  TASK_TYPE_TASK,
  TaskTotals,
} from '@totem/components/ticketing/ticketing';
import { isNotNull } from '@totem/utilities/common';

export const calculateDuration = (task: HierarchicalTask[]): Duration => {
  const calculatedDuration: Duration = {
    days: 0,
    hours: 0,
    minutes: 0,
  };

  return calculatedDuration;
};

export const aggregateHours = (task: HierarchicalTask): TaskTotals => {
  const totals: TaskTotals = {
    budgetedHours: 0,
    actualHours: 0,
    expectedDuration: {
      days: 0,
      hours: 0,
      minutes: 0,
    },
  };

  if (task.type === TASK_TYPE_TASK) {
    totals.budgetedHours += task.budgetedHours;

    totals.actualHours += task.actualHours;

    totals.expectedDuration = calculateDuration([task]);
  }

  if (isNotNull(task.children) && task.children.length > 0) {
    task.children.forEach((child) => {
      const taskHours = aggregateHours(child);
      totals.budgetedHours += taskHours.budgetedHours;

      totals.actualHours += taskHours.actualHours;
    });
  }

  return totals;
};

export const addDurations = (
  duration1: Duration,
  duration2: Duration,
): Duration => {
  // Combine all minutes, hours, and days
  const totalMinutes = duration1.minutes + duration2.minutes;
  let totalHours = duration1.hours + duration2.hours;
  let totalDays = duration1.days + duration2.days;

  // Handle minutes carry-over
  const minutesToHours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  totalHours += minutesToHours;

  // Handle hours carry-over
  const hoursToDays = Math.floor(totalHours / 24);
  const remainingHours = totalHours % 24;
  totalDays += hoursToDays;

  // Return the new, normalized Duration object
  return {
    days: totalDays,
    hours: remainingHours,
    minutes: remainingMinutes,
  };
};
